import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].GET_TRANSFERS]: {
		
		url:'/company/:companyId/machines/:machineId/transfers/',
	},
	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].GET_TRANSFER]: {
		url: '/company/:companyId/machines/:machineId/transfers/:transfersId/',
	},
	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].CREATE_TRANSFER]: {
		url:'/company/:companyId/machines/:machineId/transfers/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].PATCH_TRANSFER]: {
		url: '/company/:companyId/machines/:machineId/transfers/:transfersId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].PUT_TRANSFER]: {
		url: '/company/:companyId/machines/:machineId/transfers/:transfersId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINE_TRANSFERS].DELETE_TRANSFER]: {
		url: '/company/:companyId/machines/:machineId/transfers/:transfersId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}